import Parse from "parse";

















export class GlossaryEntry extends Parse.Object {
  constructor(data) {
    super("APP_GlossaryEntry", data );
  }
}

Parse.Object.registerSubclass("APP_GlossaryEntry", GlossaryEntry);
